module.exports = __webpack_public_path__ + "img/read2.3692ef12.png";